// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App';
import router from './router';

//load vuex state manager
Vue.use(Vuex); 
Vue.config.productionTip = false

// import Bootstrap
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

// Import vue-cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// Import vue-headful to manage html head tags
import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

// Import Ajax handler
import axios from 'axios';



// import CryptoCompare store module
import CCStore from './store/modules/CryptoCompare';

// setup Vuex state
const store = new Vuex.Store({
  modules: {
	  CCStore
  },
  state: {
	
    coinInfo: {
    	'BTC-USD': {"coin":null,"lastUpdate":null,"trade_id":0,"price":"0.00","size":"0","bid":"0.00","ask":"0.00","volume":"0","time":null},
    	'ETH-USD': {"coin":null,"lastUpdate":null,"trade_id":0,"price":"0.00","size":"0","bid":"0.00","ask":"0.00","volume":"0","time":null},
    	'BCH-USD': {"coin":null,"lastUpdate":null,"trade_id":0,"price":"0.00","size":"0","bid":"0.00","ask":"0.00","volume":"0","time":null},
    	'LTC-USD': {"coin":null,"lastUpdate":null,"trade_id":0,"price":"0.00","size":"0","bid":"0.00","ask":"0.00","volume":"0","time":null}
    },
    // store data for individual coin lookups
    cccCoinData: {},
    
    coinList: {},
    
    alerts: [],
    
    myExchanges: {},
    
  },
  mutations: {

    updateCoin (state, valueObj) {
    	if (valueObj) {
    		// update coin prices
    		if ((valueObj.coin) && (state.coinInfo[valueObj.coin])) {
    			state.coinInfo[valueObj.coin] = valueObj;
    		}    		
    	}
    },
    
    addAlert(state, input) {
    	
		  var variant;
		  var show;
		  var dismissable;
		  var message;
		  var alert = {'variant':'info', 'show':true, 'dismissible':true, 'message':null};

		  if (typeof input == 'object') {
			  if (input['variant']) {
				  alert['variant'] = input['variant'];
			  }

			  if (input['show']) {
				  alert['show'] = input['show'];
			  }

			  if (input['dismissible']) {
				  alert['dismissible'] = input['dismissible'];
			  }

			  if (input['message']) {
				  alert['message'] = String(input['message']); // cast error or other objects to string
			  }
		  } else if (typeof input == 'string') {
			  alert['message'] = input;
		  }

		  if (!alert.message) {
			  console.error("Error: alert created without message");
		  }

		  state.alerts.push(alert);
	  },
    
//    updateCccCoinData (state, valueObj) {
//    	if (valueObj) {
//    		// update coin info
//    		if ((valueObj.coin) && (state.cccCoinData)) {
//    			state.cccCoinData[valueObj.coin] = valueObj;
//    		}    		
//    	}
//    }
    
  },
  getters: {
	  
	  alerts: (state) => {
		  return state.alerts;
	  },
	  
//	  coinPrice: (state) => (coin) => {
//		  if (state.coinInfo[coin]) {
//
//			  var lastUpdate = null;
//			  var age = 0;
//			  var now = new Date();
//			  
//			  if (state.coinInfo[coin].lastUpdate) {
//				  lastUpdate = new Date(state.coinInfo[coin].lastUpdate);
//				  age = now - lastUpdate;
//			  }
//			  // refresh if more than 5 minutes old, it should not get that old if auto refreshing (see refreshCoinInfo)
//			  if ((!state.coinInfo[coin].lastUpdate) || (age > 300000))  {
//				// update the coin info then return it
//				return store.dispatch('refreshCoinInfo', coin).then(() => { return state.coinInfo[coin].price });
//			  }
//			  return state.coinInfo[coin].price
//		  }
//		  return null;
//	  },
	  
//	  coinList: (state) => {
//		  // load coinlist from static file to reduce expensive calls to cyrptocompare for relatively static data
//		  // https://min-api.cryptocompare.com/data/all/coinlist
//		  return require('@/assets/data/coinlist.json');
//		  
//	  }, 
	  
//	  cccCoinData: (state) => (coin) => {
//		  if (state.cccCoinData[coin]) {
//
//			  var lastUpdate = null;
//			  var age = 0;
//			  var now = new Date();
//			  if (state.cccCoinData[coin]) {
//				  if (state.cccCoinData[coin].lastUpdate) {
//					  lastUpdate = new Date(state.cccCoinData[coin].lastUpdate);
//					  age = now - lastUpdate;
//				  }
//				  // refresh if more than 5 minutes old, it should not get that old if auto refreshing (see refreshCoinInfo)
//				  if ((!state.cccCoinData[coin].lastUpdate) || (age > 300000))  {
//					// update the coin info then return it
//					return store.dispatch('refreshCccCoinData', coin).then(() => { return state.cccCoinData[coin] });
//				  }
//			  }
//			  // returns a promise that is instantly resolved
//			  
//			  var returnPromise = new Promise((resolve, reject) => {
//				    //console.log('Initial');
//
//				    resolve();
//				}).then(() => { return state.cccCoinData[coin] });
//			  
//			  return returnPromise;
//		  } else {
//			  // returns a promise
//			  return store.dispatch('refreshCccCoinData', coin).then(() => { return state.cccCoinData[coin] });
//		  }
//		  return null;
//	  }
  },
  actions: {
	  
	addAlert(context, alertObj) {
		context.commit('addAlert', alertObj); // add alert
	},
	
//	refreshCoinInfo(context, coin) {
//		if (coin) {
//			return new Promise((resolve) => {
//				//https://api-public.sandbox.gdax.com/products/
//				axios.get('https://api.gdax.com/products/' + coin +'/ticker').then((response) => {
//					var result = response.data;
//					result.coin = coin; // add coin to response object
//					result.lastUpdate = Date.now();
//					// set fiat prices to 2 decimals
//					if (coin.indexOf('-USD') > -1) {
//						result.price = Number(result.price).toFixed(2);
//					}
//					context.commit('updateCoin', result); // update coin
//					
//					// autorefresh every 2 minutes
//					setTimeout(function() {
//						console.log("Autorefreshing coin data: " + coin);
//						store.dispatch('refreshCoinInfo', coin);
//					}, 120000)
//					
//					
//					resolve();
//				});
//			});
//		}
//	},
	
	
	
	
  }
});

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted: function () {
	  
	  	// App startup tasks
	    
    
		// Load saved data
		this.$root.$store.commit('CCStore/initialize');
    
  }
})



// WEBPACK FOOTER //
// ./src/main.js